// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast {
  position: fixed;
  top: calc(64px + env(safe-area-inset-top, 0px));
  left: 50%;
  z-index: 9999;
  width: min(480px, calc(100vw - 32px));
  transform: translateX(-50%);
  border-radius: var(--radius-md);
  border: 1px solid var(--brand-line-control);
  background: var(--brand-surface-2);
  color: var(--brand-fg);
  opacity: 0;
  transition: opacity var(--dur-fast) var(--ease-out);
}

.toast-visible {
  opacity: 1;
  animation: aprScrimIn var(--dur-fast) var(--ease-out);
}

.toast-hidden {
  opacity: 0;
}

.toast-content {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 52px;
  padding: 6px 6px 6px 16px;
}

.toast-message {
  flex: 1;
  min-width: 0;
  font-size: 1rem;
  line-height: 1.4;
  font-weight: 500;
}

.toast-close {
  flex: none;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  color: var(--brand-muted);
}

.toast-close:hover {
  color: var(--brand-fg);
  background: var(--brand-surface);
}
`, "",{"version":3,"sources":["webpack://./src/components/Toast.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,+CAA+C;EAC/C,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,+BAA+B;EAC/B,2CAA2C;EAC3C,kCAAkC;EAClC,sBAAsB;EACtB,UAAU;EACV,mDAAmD;AACrD;;AAEA;EACE,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC","sourcesContent":[".toast {\n  position: fixed;\n  top: calc(64px + env(safe-area-inset-top, 0px));\n  left: 50%;\n  z-index: 9999;\n  width: min(480px, calc(100vw - 32px));\n  transform: translateX(-50%);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--brand-line-control);\n  background: var(--brand-surface-2);\n  color: var(--brand-fg);\n  opacity: 0;\n  transition: opacity var(--dur-fast) var(--ease-out);\n}\n\n.toast-visible {\n  opacity: 1;\n  animation: aprScrimIn var(--dur-fast) var(--ease-out);\n}\n\n.toast-hidden {\n  opacity: 0;\n}\n\n.toast-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 52px;\n  padding: 6px 6px 6px 16px;\n}\n\n.toast-message {\n  flex: 1;\n  min-width: 0;\n  font-size: 1rem;\n  line-height: 1.4;\n  font-weight: 500;\n}\n\n.toast-close {\n  flex: none;\n  display: grid;\n  place-items: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  color: var(--brand-muted);\n}\n\n.toast-close:hover {\n  color: var(--brand-fg);\n  background: var(--brand-surface);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
